import React, { Fragment, useEffect, useRef, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Grid, Table, TableBody, TableCell, TableContainer, TableRow } from '@material-ui/core';
import classNames from 'classnames';

import lang from '../../../lib/language';
import { RootState } from '../../../lib/store';
import { PositionType } from '../../../lib/store/reporting/types';

import { useIsMobile, useIsSafari } from '../../../hooks';
import { UI_ROUTES } from '../../../util/routes';
import CompanyLogo from '../../CompanyLogo/CompanyLogo';
import MyAccountButtons from '../../SwipeableItems/MyAccountButtons';
import { WATCH_LIST_TABLE_ITEMS } from '../../WatchList/WatchList.constans';

import TableRows from './TableRows';

import styles from '../TableView.module.scss';

type OwnProps = {
  tableHeaders: { [symbol: string]: string | any };
  data: any;
  isMultipleDivOfRow: boolean;
  initiallyLengthRows?: number;
  isButtonsInRow?: boolean;
  isModifyButtons?: boolean;
  companyLogos?: boolean;
  otherButtons?: string;
  hasSymbol?: boolean;
  selectedPieChartElement?: { colors: string[], symbolName: string };
  pendingOrders?: boolean;
}

type Props = OwnProps & ReduxProps;

let symbol: string = '';

const TableContainerView = (props: Props) => {
  const history = useHistory();
  const isMobile = useIsMobile();
  const isSafari = useIsSafari();
  const [selectedSymbol, setSelectedSymbol] = useState<string | undefined>();
  const [isSellOrBuySelected, setIsSellOrBuySelected] = useState<boolean>(false);

  const {
    tableHeaders,
    data,
    isMultipleDivOfRow,
    isButtonsInRow,
    isModifyButtons,
    companyLogos,
    otherButtons,
    companyLogoAndNameData,
    hasSymbol,
    selectedPieChartElement,
    initiallyLengthRows = Number.MAX_VALUE,
    pendingOrders,
  } = props;

  useEffect(() => {
    const handleClickInside = (event) => {
      if (symbol && event.composedPath().some(
        el => el.className === 'MuiTableRow-root TableView_clickableParrentTableRow__y9ohl',
      )
      && !event.target.className.includes('ButtonsSellAndBuy')
      && !event.target.className.includes('ButtonsCancelAndModify')
      && !event.target.className.includes('wrapperButtons')
      ) {
        history.push(`${UI_ROUTES.symbol}/${symbol}`);
      }
    };

    document.addEventListener('click', handleClickInside);
    return () => document.removeEventListener('click', handleClickInside);
  }, [history, isMobile]);

  const handleClickRow = (
    event: React.MouseEvent<HTMLTableRowElement>,
    symbolName: string,
    isSelectedRow?: boolean,
  ) => {
    symbol = symbolName;
    const target = event.target as HTMLElement;
    if (
      isSelectedRow
      && !isSellOrBuySelected
      && !target.className.includes('ButtonsSellAndBuy')
      && !target.className.includes('ButtonsCancelAndModify')
      && !target.className.includes('modifyButton')
      && !target.className.includes('input')
      && !target.className.includes('jss')
    ) {
      history.push(`${UI_ROUTES.symbol}/${symbol}`);
    }
  };

  return (
    <div className={isModifyButtons ? styles.tableWrapperFullWidth : styles.tableWrapper}>
      { isMobile ? (
        <MyAccountButtons
          data={data}
          hasSymbol={hasSymbol}
          companyLogos={companyLogos}
          pendingOrders={pendingOrders}
          companyLogoAndNameData={companyLogoAndNameData}
          selectedPieChartElement={selectedPieChartElement}
        />
      ) : (
        <TableContainer className={styles.wrapperTable}>
          <Table stickyHeader>
            <TableBody>
              <TableRow>
                {tableHeaders.map((column) => (
                  <TableCell
                    key={column.key}
                    className={styles.tableHeader}
                  >
                    <Grid className={classNames({
                      [styles.buttons]: isButtonsInRow,
                      [styles.tableHeaderText]: !isButtonsInRow,
                      [styles.modifyButtons]: isModifyButtons,
                    })}
                    >
                      {column.props.children}
                    </Grid>
                  </TableCell>
                ))}
              </TableRow>
            </TableBody>
            <TableBody>
              {data.map((row, index: number) => {
                let companyLogoAndName;
                if (!hasSymbol) {
                  companyLogoAndName = companyLogoAndNameData[row.name];
                }

                return (
                  <Fragment key={row.id}>
                    {
                      index < initiallyLengthRows && (
                        <TableRow
                          key={row.id}
                          className={classNames({
                            [styles.clickableParrentTableRow]: row.name,
                            [styles.noClickableParrentTableRow]: !row.name,
                            [styles.chosenItem]: row.name === selectedPieChartElement?.symbolName,
                            [styles.hoveredItem]: row.name === selectedSymbol,
                          })}
                          onClick={(event) => handleClickRow(event, row.name, row.name === selectedSymbol
                            || row.name === selectedPieChartElement?.symbolName)}
                          onMouseEnter={() => setSelectedSymbol && setSelectedSymbol(row.name)}
                          onMouseLeave={() => !isSafari && setSelectedSymbol && setSelectedSymbol('')}
                        >
                          {
                            isMultipleDivOfRow && !hasSymbol && (
                            <td className={styles.tableRow}>
                              <Grid className={styles.wrapperFirstColumn}>
                                {
                                  selectedPieChartElement && (
                                    <div
                                      style={{ background: selectedPieChartElement.colors[index] }}
                                      className={styles.colorVerticalLine}
                                    />
                                  )
                                }
                                {
                                  companyLogos
                                    ? (
                                      <CompanyLogo
                                        url={companyLogoAndName?.url}
                                        logo={companyLogoAndName?.logo}
                                        className={styles.image}
                                        symbol={row.name}
                                      />
                                    )
                                    : <img src={row.icon} className={styles.image} alt="" />
                                }
                                <Grid className={styles.columnName}>
                                  <Grid>
                                    <span className={styles.symbol}>{row.name}</span>
                                    {row.positionType === PositionType.Sell
                                    && <span className={styles.positionType}>{` ${lang.commonShort()}`}</span>}
                                  </Grid>
                                </Grid>
                              </Grid>
                            </td>
                            )
                          }
                          {
                            Object.keys(row).map((key) => {
                              const isCheckItem = WATCH_LIST_TABLE_ITEMS.includes(key);

                              if (isCheckItem) {
                                return (
                                  <TableRows
                                    key={key}
                                    row={{ ...row, companyName: companyLogoAndName?.name }}
                                    rowKey={row[key]}
                                    headerKey={key}
                                    otherButtons={otherButtons}
                                    setIsSellOrBuySelected={setIsSellOrBuySelected}
                                    showButtons={row.name === selectedSymbol}
                                  />
                                );
                              }
                              return null;
                            })
                          }
                        </TableRow>
                      )
                    }
                  </Fragment>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  companyLogoAndNameData: state.fundamental.companyLogoAndName,
});

const connector = connect(mapStateToProps);
  type ReduxProps = ConnectedProps<typeof connector>;

export default connector(TableContainerView);
